import { render, staticRenderFns } from "./EachCategory.vue?vue&type=template&id=20ed6d66&"
import script from "./EachCategory.vue?vue&type=script&lang=js&"
export * from "./EachCategory.vue?vue&type=script&lang=js&"
import style0 from "./EachCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports